import { z } from 'zod'

export const LanguageCode = z.union([z.literal('en'), z.literal('fr'), z.literal('he')]) // ISO code
export type LanguageCode = z.infer<typeof LanguageCode>
